import React from 'react';
import { motion } from 'framer-motion';
import { X, FileText } from 'lucide-react';
import { Button } from "@/components/ui/button";

export default function LegalDocumentViewer({ document, onClose }) {
  if (!document) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-end sm:items-center justify-center p-4"
      onClick={onClose}
    >
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ type: "spring", damping: 25, stiffness: 300 }}
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-t-3xl sm:rounded-3xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col"
      >
        <div className="flex items-center justify-between p-6 border-b sticky top-0 bg-white z-10">
          <div className="flex items-center gap-2">
            <FileText className="w-5 h-5 text-emerald-600" />
            <h2 className="text-xl font-bold text-gray-900">{document.title}</h2>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1">
          {document.last_updated && (
            <p className="text-sm text-gray-500 mb-4">
              Última actualización: {new Date(document.last_updated).toLocaleDateString('es-AR')}
            </p>
          )}
          <div className="prose prose-sm max-w-none text-gray-700 whitespace-pre-wrap">
            {document.content}
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}